const Items = [
  {
    id: 1,
    mainImage: "/nftssss.png",
    img: [
      "/nftssss.png",
      "/nfts 2.png",
      "/Nfts Generar.png",
      "/Nfts generar 2.png",
    ],
    features: [
      "Home",
      "Responsive Design",

    ],
    technologies: [
      "React",
      "ChakraUI",
      "Supabase",
   
    ],
    title: "Mis NFTS",
    description:
      "Les presento a mis NFTs (leopardos bomba) Esta es una coleccion de NFTs que podran encontrarla en OpenSea. Actualmente valorados en el mercado crypto por el precio de 0.06 Ethereum..",
    category: "personal",
    liveLink: "https://opensea.io/collection/amur-bomb",
    codeLink: "https://github.com/Colifaa/NFTS",
  },
  {
    id: 2,
    mainImage: "/Bocatto.png",
    img: [
      "/Bocatto.png",
      "/Bocatto 2.png",
      "/Bocatto 3.png",
      "/Bocatto 4.png",
    ],
    features: [
      "Panel Admin",
      "Operaciones CRUD (Creación, lectura, actualización y eliminación de productos)",
      "Formulario para realizar pedidos",
      "Muestra de productos",
      "Diseño responsivo",
    ],
    technologies: [
      "React",
      "React Hooks",
      "React Icons",
      "Axios",
      "CSS",
      "Supabase",
      "NodeJS",
      "ChakraUI",
    ],

    title: "Bocatto",
    description:
      "página web Bocatto, destinada a un amigo emprendedor que inicialmente ofrecía dos exquisitos sándwiches gourmet. Sin embargo, el enfoque evolucionará para abarcar una gama más amplia de productos, incluyendo bebidas y otros complementos.",
    category: "personal",
    liveLink: "https://bocatto.vercel.app/",
    codeLink: "https://github.com/Colifaa/Bocatto-",
  },
  {
    id: 3,
    mainImage: "/Ceramicas sanra.png",
    img: [
      "/Ceramicas sanra.png",
      "/Ceramicas sanra2.png",
      "/Ceramicsa sr 3.png",
      "/Ceramicas sanra4.png",
      "/Ceramicas sanra5.png",
      "/Ceramicas sanra6.png",
    ],
    features: [
      "Registro de usuario e inicio de sesión",
      "Actualizacion de contraseña",
      "Agregar productos al carrito",
      "Borrado logico",
     "Diseño responsivo",
     "Panel Admin",
      "Operaciones CRUD (Creación, lectura, actualización y eliminación de productos)",
      "Formulario para realizar pedidos",
      "Muestra de productos",
    ],
    technologies: [
      "React",
      "React Hooks",
      "React Router Dom",
      "Axios",
      "Material UI",
      "Daysi UI",
      "Tailwind",
      "ChakraUI",
      "Supabase",
      "NodeJS",
      "Dontenv",
      "Nodemon",
    ],
    title: "Ceramicas San Rafael",
    description:
     "Aplicación E-Commerce para la venta de Cerámicas abierto Fullstack creada con Supabase, Express, React y Nodejs",
    category: "business",
    liveLink: "https://www.ceramicassanrafael.com/",
    codeLink: "https://github.com/Colifaa/Ceramicas",
  },
  {
    id: 4,
    mainImage: "/Frio mundo.png",
    img: [
      "/Frio mundo.png",
      "/Frio mundo2.png",
      "/Frio mundo3.png",
      "/Frio mundo4.png",
    
    ],
    features: [
      "Agregar productos al carrito",
      "Borrado logico",
     "Diseño responsivo",
     "Panel Admin",
     "Panel Usuario",
     "Operaciones CRUD (Creación, lectura, actualización y eliminación de Poaps)",
     "Formulario para Crear Poaps",
     "Muestra de Poaps Creados",
     "Muestra de Poaps Minteados",
    ],
    technologies: [
      "React",
      "Nextjs",
      "React Hooks",
      "React Router Dom",
      "Axios",
      "Tailwind",
      "ChakraUI",
      "Heroku",
      "OpenZeppelin",
      "Alchemy",
      "Pinata",
     "Solidity",
    ],
    title: "Frio Mundo",
    description:
      "Sitio web de ventas de paneles frigorificos",
    category: "business",
    liveLink: "https://www.friomundo.online/",
    codeLink: "https://github.com/Colifaa/Frio_Mundo",
  },


  {
    id: 5,
    mainImage: "/Poaps.png",
    img: [
      "/Poaps.png",
      "/Poaps2.png",
      "/Poaps3.png",
  
    
    ],
    features: [
      "Agregar productos al carrito",
      "Borrado logico",
     "Diseño responsivo",
     "Panel Admin",
     "Operaciones CRUD (Creación, lectura, actualización y eliminación de productos)",
     "Formulario para realizar pedidos",
     "Muestra de productos",
    ],
    technologies: [
      "React",
      "React Hooks",
      "React Router Dom",
      "Axios",
      "Material UI",
      "Daysi UI",
      "Tailwind",
      "ChakraUI",
      "Supabase",
      "NodeJS",
      "Dontenv",
      "Nodemon",
    ],
    title: "Poaps generator",
    description:
      "Sitio Web para Crear Eventos y  Mintear Poap's ",
    category: "business",
    liveLink: "https://andino.vercel.app/",
    codeLink: "https://github.com/Colifaa/Andino",
   
  },
 
 
];

export default Items;
